<template>
    <div class="pro_modal">
        <Transition name="fade">
            <div @click="$GlobalStore.hideProModal()" v-if="$GlobalStore.isShowProModal()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <div class="basic_frame" :class="{ open: $GlobalStore.isShowProModal() }">
            <div style="text-align: center;">
                <div style="font-size: 20px; line-height: 28px;">몇 초 전에 전문가 한 분이<br>회원님의 능력치를 분석했어요!</div>
            </div>
            <div style="margin-top: 30px;">
                <AbilityAnalysis :isPro="false" backGroundAndTextColor="#F28801" title="능력치 분석" :good="65" :bad="35" :feedBackContents="feedBackContents"></AbilityAnalysis>
            </div>
            <div style="margin-top: 40px; text-align: center; width: calc(100% + 20px); margin-left: -10px; margin-bottom: 40px;">
                <div style="font-size: 14px; line-height: 20px; color: #606060;">좋은 능력치를 가졋어요! 어떤 능력이<br> 이런 수치가 나왔는지는 확인해볼까요?<br> 포지션 찾기 PRO를 진행하면 바로 확인해볼 수 있어요.</div>
            </div>
            <div style="height: 67px; display: flex; width: calc(100% + 40px); margin-left: -20px; margin-bottom: -20px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;">
                <div @click="findPositionPro" style="flex-basis: 65%; border-bottom-right-radius: 0; background-color: var(--color-main);" class="pro_modal_btn">포지션 찾기 PRO로 피드백 받기</div>
                <div @click="$GlobalStore.hideProModal()" style="flex-basis: 35%; border-bottom-left-radius: 0; background-color: #210f03;" class="pro_modal_btn">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
import { AbilityAnalysis } from '@/components/common';

export default {
    name: "showpromodal",
    components: { AbilityAnalysis },
    data() {
        return {
            feedBackContents: '좋은 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)을 가지셨군요. (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)을 더 키울 수 있는 약간의 피드백만 드려도 괜찮겠어요!',
        }
    },
    methods: {
        findPositionPro() {
            this.$GlobalStore.hideProModal()
            this.$GlobalStore.addModal('FindPositionProStart', { originallyPosition: this.$GlobalStore.loginInfo().position })
        },
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.pro_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
}

.basic_frame {
    width: calc(100% - 40px);
    background-color: #fff;
    padding: 20px;
    border-radius: 20px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
}

.pro_modal_btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: red;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.basic_frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>

